"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _NormalInput = _interopRequireDefault(require("./NormalInput"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _CustomIcon = _interopRequireDefault(require("./CustomIcon.style"));

var renderIcon = function renderIcon(icon) {
  if (!icon) {
    return null;
  }

  if (_react.default.isValidElement(icon)) {
    return icon;
  }

  return _react.default.createElement(_Icon.default, (0, _extends2.default)({
    className: "inputIcon"
  }, icon));
};

var CustomIconInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CustomIconInput, _Component);

  function CustomIconInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CustomIconInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CustomIconInput).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onFocusHandler", function () {
      _this.setState({
        onFocus: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBlurHandler", function () {
      _this.setState({
        onFocus: false
      });
    });
    _this.state = {
      onFocus: false
    };
    return _this;
  }

  (0, _createClass2.default)(CustomIconInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          wrapperProps = _this$props.wrapperProps,
          warning = _this$props.warning,
          error = _this$props.error,
          value = _this$props.value,
          type = _this$props.type,
          icon = _this$props.icon,
          iconPosition = _this$props.iconPosition,
          inputProps = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "className", "wrapperProps", "warning", "error", "value", "type", "icon", "iconPosition"]);
      var onFocus = this.state.onFocus;
      return _react.default.createElement("label", (0, _extends2.default)({}, wrapperProps, {
        className: (0, _classnames.default)(wrapperProps.className, _CustomIcon.default.label(theme, warning, error, type, onFocus))
      }), iconPosition === 'left' && renderIcon(icon), _react.default.createElement(_NormalInput.default, (0, _extends2.default)({
        className: (0, _classnames.default)(className, _CustomIcon.default.input(theme, type))
      }, inputProps, {
        value: value,
        type: type,
        style: {
          paddingLeft: 0
        },
        onFocus: this.onFocusHandler,
        onBlur: this.onBlurHandler
      })), iconPosition === 'right' && renderIcon(icon), _react.default.createElement("span", {
        className: _CustomIcon.default.span()
      }, error || warning));
    }
  }]);
  return CustomIconInput;
}(_react.Component);

CustomIconInput.defaultProps = {
  placeholder: 'Type to search...',
  wrapperProps: {},
  error: null,
  warning: null,
  value: undefined,
  type: 'medium'
};
CustomIconInput.propTypes = {
  placeholder: _propTypes.default.string,
  wrapperProps: _propTypes.default.shape({}),
  error: _propTypes.default.string,
  warning: _propTypes.default.string,
  value: _propTypes.default.string,
  type: _propTypes.default.oneOf(['small', 'medium'])
};

var _default = (0, _emotionTheming.withTheme)(CustomIconInput);

exports.default = _default;